import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';

const { Paragraph, Title } = Typography;

const Hero = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__hero">
      <div className="columns" />
      <Title level={1}>
        <FormattedMessage id={homeMessageId('hero.title')} />
      </Title>
      <Paragraph>
        <span className="home-page__hero-accent">
          <FormattedMessage id={homeMessageId('hero.subtitleAccent')} />
        </span>{' '}
        <span className="home-page__hero-subtitle">
          <FormattedMessage id={homeMessageId('hero.subtitleRest')} />
        </span>
      </Paragraph>
      <Button
        className="home-page__primary-button"
        type="primary"
        onClick={openRegister}
      >
        <FormattedMessage id={homeMessageId('button.more')} />
        <AiIcon name="btn-primary-circle-arrow" />
      </Button>
    </section>
  );
};

export default Hero;
